import { render, staticRenderFns } from "./TabelaSancoesRestricoesPf.vue?vue&type=template&id=0e0f043a&lang=pug"
import script from "./TabelaSancoesRestricoesPf.vue?vue&type=script&lang=js"
export * from "./TabelaSancoesRestricoesPf.vue?vue&type=script&lang=js"
import style0 from "./TabelaSancoesRestricoesPf.vue?vue&type=style&index=0&id=0e0f043a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports